import { useCallback, useMemo } from 'react';

import map from 'lodash/map';

import {
  useLaborLevelDesignations,
  useLaborLevelFacilitiesGet,
} from '@sbv-clients/data-access-api';
import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import { useAppendAllOption } from './util';
import useAutoSelectValue from './util/use-auto-select-value';

export function FacilityFilter({
  withAllOption = false,
  autoSelectIfEmpty = false,
  useContextFn,
  onChange: callback,
  filteredByOpeningTemplates = true,
  errorMessages = {},
}: {
  withAllOption?: boolean;
  autoSelectIfEmpty?: boolean;
  onChange?: (value: number) => void;
  useContextFn: () => {
    facilityId?: number;
    setFacilityId: (value: number) => void;
  };
  filteredByOpeningTemplates?: boolean;
  errorMessages?: Record<string, string>;
}) {
  const { facilityId: value, setFacilityId: onChange } = useContextFn();

  const { data, isLoading, isSuccess } = useLaborLevelFacilitiesGet({
    filteredByOpeningTemplates: filteredByOpeningTemplates,
  });

  const options = useMemo(
    () =>
      map(data, (item) => ({
        id: item.facilityId as number,
        label: item.facilityName ?? '',
        value: item.facilityId as number,
      })),
    [data]
  );

  useAppendAllOption(options, withAllOption);

  const sharedOnChangeHandler = useCallback(
    (value: number) => {
      onChange(value);
      callback?.(value);
    },
    [callback, onChange]
  );

  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: sharedOnChangeHandler,
    isSuccess,
  });
  const { data: laborLevelDesignations } = useLaborLevelDesignations();
  const facilityHeaderName = laborLevelDesignations?.facility?.name ?? '';
  const handleChange = useTransformSelectValue<number>(sharedOnChangeHandler);
  const helperText = errorMessages['facilityId'];

  return (
    <Select
      isLoading={isLoading}
      fullWidth
      size="small"
      value={value}
      label={facilityHeaderName}
      options={options}
      onChange={handleChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
